import React from 'react';
import './ScrollHeader.css';

const ScrollHeader = () => {
  return (
    <div className="scroll-header">
      <div className="scroll-title">ZACH BILES</div>
      <nav className="scroll-nav">
        <a href="#about">ABOUT</a>
        <a href="#resume">RESUME</a>
        <a href="#contact">CONTACT</a>
      </nav>
    </div>
  );
};

export default ScrollHeader;